import { ChartsByLabel } from 'interfaces/performanceTest';
import { useEffect, useState } from 'react';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {
  commonXAxisProps,
  fillInTimeGaps,
  LabeledDataPoint,
  reduceChartsByLabel,
} from './helpers';
import Loading from './Loading';
import TooltipContent from './TooltipContent';

interface Props {
  ticks: number[];
  charts: ChartsByLabel;
  loading: boolean;
}

const fillColors = ['#8FB9AA', '#5CCCCE', '#304D63', '#538573', '#E6A332'];

const selectFillColor = (i) => {
  return fillColors[i % (fillColors.length - 1)];
};

const RequestCount: React.FC<Props> = ({ ticks, charts, loading }) => {
  const [formattedDataPoints, setFormattedDataPoints] = useState<
    LabeledDataPoint<number>[]
  >([]);
  const [labels, setLabels] = useState<string[]>([]);

  useEffect(() => {
    if (charts) {
      setFormattedDataPoints(
        fillInTimeGaps(
          reduceChartsByLabel<number>(charts, 'requests'),
          (timeStamp) => ({ timeStamp, metricByLabel: {} }),
          (timeStamp, existing) => ({
            timeStamp,
            metricByLabel: existing.metricByLabel,
          })
        )
      );
      setLabels(Object.keys(charts));
    }
  }, [charts]);

  return (
    <div className="h-44 my-5">
      <ResponsiveContainer width="100%" height="100%">
        {loading ? (
          <Loading />
        ) : (
          <BarChart
            width={500}
            height={400}
            data={formattedDataPoints}
            margin={{
              top: 10,
              right: 30,
              left: 10,
              bottom: 10,
            }}
          >
            <XAxis {...commonXAxisProps} ticks={ticks} />
            <YAxis />
            {labels.map((label, i) => (
              <Bar
                name={label}
                label={label}
                stackId="a"
                dataKey={(row) => row.metricByLabel[label] || 0}
                fill={selectFillColor(i)}
                key={i}
              />
            ))}
            <Tooltip content={TooltipContent} />
          </BarChart>
        )}
      </ResponsiveContainer>
    </div>
  );
};

export default RequestCount;
